import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useTheme } from "@emotion/react";
import { Button, Grid2 } from "@mui/material";
import "./index.scss";
import UserIcon from "assets/images/userIconOn.png";
import CloseIcon from "assets/images/closeIcon.png";
import StepperComponent from "components/stepper";
import { LoadingButton } from "@mui/lab";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "fit-content",
  maxWidth: "450px",
  maxHeight: "600px",
  p: 0,
  m: 0,
  outline: "none",
  padding: "0px 10px",
};

const CustomModalRegister = ({
  open,
  handleClose,
  title = null,
  description,
  children,
  customstyle,
  activeStep = 0,
  titleBody,
  buttonFunction = () => {},
  buttonText = "ادامه",
  loadingButton,
  disabledButton,
  buttonFunctionCancel = null,
  buttonCancelText = "لغو",
  companionName = null,
}) => {
  const theme = useTheme();
  return (
    <Modal open={open} style={{ backdropFilter: "blur(3px)" }}>
      <Box
        sx={{
          ...modalStyle,
          ...customstyle,
        }}
        className="container-modal-register"
      >
        <Grid2 container columns={12} className="top-box-title">
          <Grid2 item size={{ xs: 1 }} className="item-top-box">
            <img src={UserIcon} alt="" />
          </Grid2>
          <Grid2 item size={{ xs: 10 }} className="item-top-box-title">
            {title}
          </Grid2>
          <Grid2
            item
            size={{ xs: 1 }}
            className="item-top-box item-close"
            onClick={handleClose}
          >
            <img src={CloseIcon} alt="" />
          </Grid2>
        </Grid2>
        <hr
          className="divider"
          size={1}
          color={theme.palette.defultText.main}
        />
        <Grid2 container columns={12} className="container-stepper">
          <StepperComponent
            steps={["شماره موبایل", "کد تایید", "صدور آن کارت", "احراز هویت"]}
            activeStep={activeStep}
          />
        </Grid2>
        <hr
          className="divider"
          size={1}
          color={theme.palette.defultText.main}
        />
        {companionName !== null && (
          <>
            <Grid2 container columns={12} className="companion-name-box">
              <Grid2 item size={{ xs: 1 }} className="item-companion-icon">
                <img src={UserIcon} alt="" />
              </Grid2>
              <Grid2 item size={{ xs: 11 }} className="item-companion-name">
                {companionName}
              </Grid2>
            </Grid2>
            <hr
              className="divider"
              size={1}
              color={theme.palette.defultText.main}
            />
          </>
        )}

        <Grid2 container columns={12} className="container-body">
          <Grid2 item size={{ sx: 12 }} className="title-body">
            {titleBody}
          </Grid2>
          <Grid2 item size={{ sx: 12 }} className="content-body">
            {children}
          </Grid2>
        </Grid2>
        <Grid2 container columns={12} spacing={1} className="container-button">
          {buttonFunctionCancel !== null && (
            <Grid2 item size={{ xs: 3 }}>
              <Button
                variant="contained"
                className="button-modal-register-cancel"
                onClick={() => {
                  buttonFunctionCancel();
                }}
              >
                {buttonCancelText}
              </Button>
            </Grid2>
          )}
          <Grid2 item size={{ xs: buttonFunctionCancel !== null ? 9 : 12 }}>
            <LoadingButton
              loading={loadingButton}
              variant="contained"
              className="button-modal-register-continue"
              onClick={buttonFunction}
              loadingPosition="end"
              disabled={disabledButton}
            >
              {buttonText}
            </LoadingButton>
          </Grid2>
        </Grid2>
      </Box>
    </Modal>
  );
};

export default CustomModalRegister;
